<template>
  <div class="login-page">
    <div class="login-card">
      <img class="login-logo" :src="logoUrl" alt="GLT" />
      <h1 class="login-title">{{ $t('app.name') }}</h1>

      <el-form :model="form" :rules="rules" ref="formRef" label-position="top" class="login-form">
        <el-form-item :label="$t('loginPage.account')" prop="username">
          <el-input
            v-model="form.username"
            :placeholder="$t('loginPage.accountPh')"
            @keyup.enter.native="onLogin"
          />
        </el-form-item>
        <el-form-item :label="$t('loginPage.password')" prop="password">
          <el-input
            v-model="form.password"
            :placeholder="$t('loginPage.passwordPh')"
            type="password"
            show-password
            @keyup.enter.native="onLogin"
          />
        </el-form-item>
        <el-form-item class="login-submit">
          <el-button type="primary" :loading="loading" class="login-btn" @click="onLogin">
            {{ $t('loginPage.submit') }}
          </el-button>
        </el-form-item>
      </el-form>

      <div v-if="errMsg" class="login-err">{{ errMsg }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import logo from '@/assets/images/logo.png'

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      errMsg: '',
      logoUrl: logo,
      form: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    rules() {
      return {
        username: [{ required: true, message: this.$t('loginPage.accountRequired'), trigger: 'blur' }],
        password: [{ required: true, message: this.$t('loginPage.passwordRequired'), trigger: 'blur' }]
      }
    }
  },
  methods: {
    ...mapActions(['login']),
    onLogin() {
      this.errMsg = ''
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.loading = true
        this.login(this.form)
          .then(() => {
            this.$router.replace('/home')
          })
          .catch(e => {
            this.errMsg = (e && e.message) || this.$t('loginPage.failed')
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: var(--color-bg);
}

.login-card {
  width: min(380px, 100%);
  padding: 36px 32px 32px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: 10px;
  box-shadow: var(--shadow-card);
}

.login-logo {
  display: block;
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  border-radius: 10px;
  object-fit: cover;
  background: #111;
}

.login-title {
  margin: 0 0 24px;
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  color: var(--color-text);
}

.login-form :deep(.el-form-item__label) {
  float: none;
  display: block;
  padding: 0 0 6px;
  line-height: 1.4;
  font-size: 13px;
  font-weight: 400;
  color: var(--color-text-sub) !important;
}

.login-form :deep(.el-form-item) {
  margin-bottom: 16px;
}

.login-form :deep(.el-form-item__content) {
  margin-left: 0 !important;
}

.login-form :deep(.el-input__inner) {
  height: 40px;
  line-height: 40px;
  border-radius: 6px;
}

.login-submit {
  margin-bottom: 0;
  margin-top: 8px;
}

.login-btn {
  width: 100%;
  height: 40px;
  font-weight: 500;
}

.login-err {
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 13px;
  text-align: center;
  color: #dc2626;
  background: rgba(220, 38, 38, 0.06);
}
</style>
